import React, { useState, useReducer, useEffect } from 'react';
import { useStaticQuery } from 'gatsby';
import { cartReducer, getCartFromLocal } from '../reducers/cartReducer';
import { productReducer, setProductStructure } from '../reducers/productReducer';
import { jsx as ___EmotionJSX } from "@emotion/react";
export const StoreContext = /*#__PURE__*/React.createContext({});
export const StoreProvider = _ref => {
  let {
    children
  } = _ref;
  const {
    sitePlugin
  } = useStaticQuery(query);
  const {
    0: settings,
    1: setSettings
  } = useState({
    loading: true,
    data: null,
    error: null
  });
  const {
    0: paypal,
    1: setPaypal
  } = useState(null);
  const {
    0: storeRootPath,
    1: setStoreRootPath
  } = useState('/' + sitePlugin.pluginOptions.path);
  const {
    0: projectName,
    1: setProjectName
  } = useState(null);
  const {
    0: cart,
    1: cartDispatcher
  } = useReducer(cartReducer, {}, getCartFromLocal);
  const {
    0: categoryFilter,
    1: setCategoryFilter
  } = useState(null);
  const {
    0: manufacturersFilter,
    1: setManufacturersFilter
  } = useState([]);
  const {
    0: subcategoriesFilter,
    1: setSubcategoriesFilter
  } = useState([]);
  const {
    0: attributesFilter,
    1: setAttributesFilter
  } = useState({});
  const {
    0: tagFilter,
    1: setTagFilter
  } = useState('');
  const {
    0: sort,
    1: setSort
  } = useState([]);
  const {
    0: meta,
    1: setMeta
  } = useState(null);
  const {
    0: page,
    1: setPage
  } = useState(0);
  const {
    0: currentProduct,
    1: currentProductDispatcher
  } = useReducer(productReducer, {}, setProductStructure);
  useEffect(() => {
    setPage(0);
  }, [categoryFilter, manufacturersFilter, subcategoriesFilter]);
  useEffect(() => {
    if (settings.data) {
      const pp = settings.data.payment_methods.filter(_ref2 => {
        let {
          payment_id
        } = _ref2;
        return payment_id.id.toString() === '4';
      });
      if (pp.length === 1) {
        setPaypal(settings.data.paypal_client_id);
      }
    }
  }, [settings]);
  return ___EmotionJSX(StoreContext.Provider, {
    value: {
      settings,
      setSettings,
      paypal,
      setPaypal,
      storeRootPath,
      setStoreRootPath,
      projectName,
      setProjectName,
      categoryFilter,
      setCategoryFilter,
      manufacturersFilter,
      setManufacturersFilter,
      subcategoriesFilter,
      setSubcategoriesFilter,
      attributesFilter,
      setAttributesFilter,
      tagFilter,
      setTagFilter,
      sort,
      setSort,
      cart,
      cartDispatcher,
      meta,
      setMeta,
      page,
      setPage,
      currentProduct,
      currentProductDispatcher
    }
  }, children);
};
const query = "1965477573";